import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TableRestaurantIcon(props: IconProps) {
    return <Icon {...props} iconKey={"table_restaurant"}/>
}
